// HomePage.js or any other component
import React, { useEffect, useState } from "react";
import "./HomePage.css";
import "../CSS/fonts.css";
import moment from 'moment';
import iouConnectImage from "../Assets/iou-connect.png";
import driveOffConnectImage from "../Assets/driveoff-connect.png";
import lookupConnectImage from "../Assets/lookup-connect.png";
import paymentConnectImage from "../Assets/payment-connect.png";
import userSession from "../Constant/auth";
import usePumpData from "../API/usePumpData";
import { APP_SERVICES_URL } from "../Constant/constant";
import CameraBox, { BeepManager } from "../components/CameraBox";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import CenteredMenuModal from "./CenteredMenuModal";
import IouModal from "../components/Modals/IouModal";
import DriveOffModal from "../components/Modals/DriveOffModal";
import PaymentModal from "../components/Modals/PaymentModal";
import ShowImageModal from "../components/Modals/ShowImageModal";
import ManualInputModal from "../components/Modals/ManualInputModal";
import LogoutModal from "../components/Modals/LogoutModal";
import SignalModal from "../components/Modals/SignalModal";
import RegoCheckModal from "../components/Modals/RegoCheckModal";
import LoginInfoModal from "../components/Modals/LoginInfoModal";
import Navbar from "../components/Navbar";
import NotificationModal from "../components/Modals/NotificationModal";
import ReportStolenPlateModal from "../components/Modals/ReportStolenPlateModal";
import axios from "axios";
import ShopLiftingModal from "../components/Modals/ShopLiftingModal";
import { installAudioKeepAlive } from "../Constant/audio";
import { isSessionValid, forceLogout } from "../Constant/auth";
import { nextRetryDelayMs } from "../Constant/session";

// Minimal base64 mp4 used to keep older iOS awake when the Wake Lock API is absent
const LEGACY_WAKE_VIDEO_SRC = "data:video/mp4;base64,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";

const HomePage = () => {
  const { CustID, authHeader, site, token } = userSession;
  const { totalPump, pumpDetails } = usePumpData(
    APP_SERVICES_URL,
    CustID,
    site.name,
    authHeader
  );

  const [pumpCount, setPumpCount] = useState(0);
  useEffect(() => {
    setPumpCount(totalPump);
  }, [totalPump]);

  // Fix: Unlock Audio Context & Keep Screen Awake for iOS/iPad
  useEffect(() => {
    // Audio: keep the context resumable for the whole session. The listeners
    // deliberately stay attached - iOS can suspend audio any number of times
    // over a multi-day shift, and the old one-shot unlock never recovered.
    installAudioKeepAlive(() => BeepManager.wakeUp());

    // Screen Wake Lock (Modern API)
    let wakeLock = null;
    const requestWakeLock = async () => {
      try {
        if ('wakeLock' in navigator && document.visibilityState === 'visible') {
          wakeLock = await navigator.wakeLock.request('screen');
          // console.log('Screen Wake Lock active');
        }
      } catch (err) {
        console.error(`Wake Lock Error: ${err.name}, ${err.message}`);
      }
    };

    // Legacy Wake Lock Fallback for older iOS (Hidden Video Method)
    let videoElement = null;
    if (!('wakeLock' in navigator)) {
      videoElement = document.createElement('video');
      videoElement.setAttribute('playsinline', '');
      videoElement.setAttribute('no-controls', '');
      videoElement.muted = true;
      videoElement.loop = true;
      videoElement.style.height = '1px';
      videoElement.style.width = '1px';
      videoElement.style.opacity = '0';
      videoElement.style.position = 'absolute';
      videoElement.style.pointerEvents = 'none';
      videoElement.src = LEGACY_WAKE_VIDEO_SRC;
      document.body.appendChild(videoElement);
      videoElement.play().catch(console.error);
    }

    requestWakeLock();

    const handleVisibilityChange = async () => {
      if (document.visibilityState !== 'visible') return;
      // Retry unconditionally: the lock is dropped whenever the tab is hidden,
      // and the old `wakeLock !== null` guard meant a failed first request was
      // never retried at all.
      await requestWakeLock();
      if (videoElement) videoElement.play().catch(console.error);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (wakeLock !== null) {
        wakeLock.release().catch(console.error);
      }
      if (videoElement) {
        videoElement.pause();
        videoElement.src = "";
        document.body.removeChild(videoElement);
      }
    };
  }, []);

  // Session expiry watchdog: stop beeping and send the operator back to login
  // rather than leaving a dead screen up.
  useEffect(() => {
    const checkSession = () => {
      if (!isSessionValid()) {
        BeepManager.cleanup();
        forceLogout("session expired on home screen");
      }
    };

    checkSession();
    const intervalId = setInterval(checkSession, 60 * 1000);
    document.addEventListener('visibilitychange', checkSession);

    return () => {
      clearInterval(intervalId);
      document.removeEventListener('visibilitychange', checkSession);
    };
  }, []);

  const url = `${APP_SERVICES_URL}/sn-events-service/${CustID}/liveEvents?token=${token}`;
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false); //handle success notifications for payemnt modal
  const [successDriveOff, setSuccessDriveOff] = useState(false); //handle success notifications for drive off
  const [successIOU, setSuccessIOU] = useState(false); //handle success notifications for iou
  const [successShoplift, setSuccessShoplift] = useState(false); //handle success notifications for iou
  const [sseConnected, setSSEConnected] = useState(false);
  const [currentSiteEventsResponse, setCurrentSiteEventsResponse] = useState(false);
  const [currentSiteEventsError, setCurrentSiteEventsError] = useState(false);
  const [liveEventsError, setLiveEventsError] = useState(false);
  const [titleData, settitleData] = useState("");
  const [bodyData, setBodyData] = useState("");

  const [shopliftNotificationError, setShopliftNotificationError] = useState(null);
  const [showModalMenuModal, setShowModalMenuModal] = useState(false);
  const [cameraData, setCameraData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control the modal visibility
  const [selectedEventData, setSelectedEventData] = useState({}); // selected event
  const [driveoffModalShow, setDriveoffModalShow] = useState(false);
  const [iouModalShow, setIOUModalShow] = useState(false);
  const [imageModalShow, setImageModalShow] = useState(false);
  const [regoCheckModalShow, setRegoCheckModalShow] = useState(false);
  const [manualInputModalShow, setManualInputModalShow] = useState(false);
  const [shopliftingModalShow, setShopliftingModalShow] = useState(false);

  const [reportStolenPlateModalShow, setReportStolenPlateModalShow] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [manualInputSuccess, setManualInputSuccess] = useState(null);
  const [showModalSignalModal, setShowModalSignalModal] = useState(false);

  const handleOpenSignalModal = () => setShowModalSignalModal(true);
  const handleCloseSignalModal = () => setShowModalSignalModal(false);
  // function to close side navbar once other modal opens
  const triggerCloseButtonClick = () => {
    const closeButton = document.querySelector(
      '.btn-close[data-bs-dismiss="offcanvas"]'
    );
    if (closeButton) {
      closeButton.click();
    }
  };

  const handleShowDriveOff = () => {
    setDriveoffModalShow(true);
    setShowModalMenuModal(false);
    triggerCloseButtonClick();
  };
  const handleCloseDriveOff = () => setDriveoffModalShow(false);
  const handleShowIOU = () => {
    setIOUModalShow(true);
    setShowModalMenuModal(false);
    triggerCloseButtonClick();
  };
  const handleCloseIOU = () => setIOUModalShow(false);
  const handleShowImageModal = () => {
    setImageModalShow(true);
    setShowModalMenuModal(false);
    triggerCloseButtonClick();
  };
  const handleCloseImageModal = () => setImageModalShow(false);
  const handleShowRegoCheckModal = () => setRegoCheckModalShow(true);
  const handleCloseRegoCheckModal = () => setRegoCheckModalShow(false);

  const handleShowManualInputModal = () => {
    setManualInputModalShow(true);
    setShowModalMenuModal(false);
    triggerCloseButtonClick();
  };

  const handleShowShopliftingModal = () => {
    setShopliftingModalShow(true);
    setShowModalMenuModal(false);
    triggerCloseButtonClick();
  };

  const handleShowStolenPlateModal = () => {
    setReportStolenPlateModalShow(true);
  };
  const handleCloseStolenPlateModal = () =>
    setReportStolenPlateModalShow(false);

  const handleClosemanualInputModal = () => setManualInputModalShow(false);
  const handleCloseShopliftingModal = () => setShopliftingModalShow(false);

  const handleShowPaymentModal = () => {
    setShowPaymentModal(true);
    triggerCloseButtonClick();
  };
  const handleClosePaymentModal = () => setShowPaymentModal(false);

  useEffect(() => {
    const updateCameraDataWithPumpDetails = () => {
      // 1. Remove duplicates by pump.number
      const uniquePumps = [
        ...new Map(
          pumpDetails
            .filter((pump) => !isNaN(parseInt(pump.number)))
            .map((pump) => [pump.number, pump])
        ).values(),
      ];

      // 2. Sort valid unique pumps by number
      const sortedValidPumps = [...uniquePumps].sort(
        (a, b) => parseInt(a.number) - parseInt(b.number)
      );

      // 3. Create camera data from valid pumps with id = pump number (as number)
      const cameraDataWithPumps = sortedValidPumps.map((pump) => ({
        id: parseInt(pump.number),
        eventID: "",
        ocr: "",
        previousOffenceType: "",
        pumpName: pump.name,
        eventTime: "",
      }));

      // 4. Calculate total boxes needed for a consistent grid
      const totalBoxes = getBoxSize(cameraDataWithPumps.length);
      const emptySlots = totalBoxes - cameraDataWithPumps.length;

      // 5. Find max id in existing pumps to avoid duplicate keys
      const maxId =
        cameraDataWithPumps.length > 0
          ? Math.max(...cameraDataWithPumps.map((pump) => pump.id))
          : 0;

      // 6. Add empty placeholders for remaining slots with unique ids
      const placeholderCameraData = Array.from({ length: emptySlots }, (_, i) => ({
        id: maxId + i + 1,
        eventID: "",
        ocr: "",
        previousOffenceType: "",
        pumpName: "",
        eventTime: "",
      }));

      // 7. Combine and set
      const finalCameraData = [...cameraDataWithPumps, ...placeholderCameraData];
      setCameraData(finalCameraData);
    };

    if (pumpDetails.length > 0) {
      updateCameraDataWithPumpDetails();
    }

    // eslint-disable-next-line
  }, [pumpDetails]);





  // Function to get the box size based on totalPump
  const getBoxSize = (totalPump) => {
    if (totalPump <= 4) {
      return 4;  // 2×2
    } else if (totalPump <= 9) {
      return 9;  // 3×3
    } else if (totalPump <= 16) {
      return 16; // 4×4
    } else if (totalPump <= 25) {
      return 25; // 5×5
    } else if (totalPump <= 36) {
      return 36; // 6×6
    } else if (totalPump <= 49) {
      return 49; // 7×7
    } else {
      return 64; // 8×8 for more than 49
    }
  };


  // Calculate box size and dimensions
  const boxSize = getBoxSize(totalPump);
  const gridSize = Math.sqrt(boxSize); // Calculate grid dimensions
  const openPopup = (camera) => {
    setShowModalMenuModal(true);
    setSelectedEventData(camera);
  };

  const handleClose = () => setShowModalMenuModal(false);

  // Function to establish the SSE connection and fetch data
  // Keep a persistent reference for the current SSE connection
  let eventSourceRef = null;
  let heartbeatTimeoutRef = null; // Reference for heartbeat timeout
  let reconnectTimeoutRef = null; // Pending backed-off reconnect
  let reconnectAttempts = 0; // Consecutive failed connections, drives the backoff

  // Function to establish the SSE connection and fetch data
  const fetchSSEData = () => {
    // Close any existing connection before opening a new one
    if (eventSourceRef) {
      // console.log("Closing old SSE connection before opening new one...");
      eventSourceRef.close();
    }

    // Clear any existing heartbeat timeout
    if (heartbeatTimeoutRef) {
      clearTimeout(heartbeatTimeoutRef);
    }

    const eventSource = new EventSource(url);
    eventSourceRef = eventSource; // store the current instance

    // Function to reset heartbeat timer
    const resetHeartbeatTimer = () => {
      // Clear existing timeout
      if (heartbeatTimeoutRef) {
        clearTimeout(heartbeatTimeoutRef);
      }

      // Set new timeout for 1 minute (60000ms)
      heartbeatTimeoutRef = setTimeout(() => {
        console.warn("⚠️ No heartbeat received for 1 min 10 seconds. Reconnecting SSE...");

        // Close the current connection
        if (eventSourceRef) {
          eventSourceRef.close();
          eventSourceRef = null;
        }

        // Reconnect
        fetchSSEData();
      }, 75000); // 1 minute 15 seconds
    };
    // Log a message when the SSE connection is opened
    eventSource.onopen = () => {
      reconnectAttempts = 0;
      setSSEConnected(true);
      // console.log("✅ SSE connection established");
      // Start heartbeat timer when connection opens
      resetHeartbeatTimer();
    };

    document.cookie = `auth-token=${token}; Path=/scancam-edge; Max-Age=86400`;

    eventSource.onmessage = (event) => {
      // Reset heartbeat timer on every message (including heartbeats)
      resetHeartbeatTimer();
      try {
        // ✅ Skip empty heartbeat messages (no actual data)
        if (!event.data || event.data.trim() === "") {
          // console.log("Skipping empty heartbeat...");
          return;
        }

        const response = JSON.parse(event.data);
        // eslint-disable-next-line
        const ocr = response.ocr;
        // eslint-disable-next-line
        const pumpName = response.pumpName;

        setCameraData((prevCameraData) =>
          prevCameraData.map((camera) => {
            try {
              const now = moment.utc().toISOString();
              return camera.pumpName === response.pumpName
                ? {
                  ...camera,
                  eventID: response.id,
                  ocr: response.ocr,
                  previousOffenceType: response.previousOffenceType,
                  eventTime: response.created,
                  currentJStime: now,
                  eventAddedTime: now,
                }
                : camera;
            } catch (error) {
              return camera;
            }
          })
        );
      } catch (error) {
        // console.log('\x1b[31mNo OCR Data Detected. Rechecking.\x1b[0m');
      }
    };

    eventSource.onerror = (error) => {
      // console.error("❌ SSE Error:", error);
      setLiveEventsError(true);

      // Clear heartbeat timer on error
      if (heartbeatTimeoutRef) {
        clearTimeout(heartbeatTimeoutRef);
      }

      if (eventSourceRef) {
        // console.log("Closing broken SSE connection...");
        eventSourceRef.close();
        eventSourceRef = null;
      }

      // An expired token makes the stream fail every time, so stop reconnecting
      // in a tight loop and send the operator back to login instead.
      if (!isSessionValid()) {
        BeepManager.cleanup();
        forceLogout("live events stream rejected an expired session");
        return;
      }

      // Reconnect with exponential backoff. A 401 never reaches here (the
      // session check above handles it) and a 503 means the server could not
      // check the token because of a database problem - so keep the session and
      // retry gently instead of hammering the server every second.
      if (reconnectTimeoutRef) {
        clearTimeout(reconnectTimeoutRef);
      }
      const delay = nextRetryDelayMs(reconnectAttempts);
      reconnectAttempts += 1;
      reconnectTimeoutRef = setTimeout(() => {
        reconnectTimeoutRef = null;
        fetchSSEData();
      }, delay);
    };
  };

  // Call the API when the component mounts (you can call it wherever needed)
  useEffect(() => {
    if (site.product !== "Connect") {
      fetchSSEData(); // establish SSE connection
    }

    // Clean up the SSE connection when the component unmounts
    return () => {
      // console.log("🧹 Cleaning up SSE connection...");
      const isLogged = localStorage.getItem("isLogged");
      // Clear heartbeat timer
      if (heartbeatTimeoutRef) {
        clearTimeout(heartbeatTimeoutRef);
        heartbeatTimeoutRef = null;
      }
      if (reconnectTimeoutRef) {
        clearTimeout(reconnectTimeoutRef);
        reconnectTimeoutRef = null;
      }

      if (eventSourceRef) {
        eventSourceRef.close();
        eventSourceRef = null;
      }
      if (isLogged === "false") {
        setSSEConnected(false);
        setCurrentSiteEventsResponse(false);
      }
    };
    // eslint-disable-next-line
  }, []);




  // const updateEventTime = () => {
  //   setCameraData((prevCameraData) => {
  //     return prevCameraData.map((cameraItem) => {
  //       if (cameraItem.eventID && !cameraItem.currentJStime) {
  //         const currentJStime = moment.utc().toISOString(); // UTC ISO string
  //         console.log(`Updating currentJStime for camera with ID ${cameraItem.id}: ${currentJStime}`);
  //         return {
  //           ...cameraItem,
  //           currentJStime,
  //         };
  //       }
  //       return cameraItem;
  //     });
  //   });
  // };




  // // Set interval to update the event time every 5 seconds
  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     // console.log("Updating event times for all camera items...");
  //     updateEventTime(); // Call the update function every 5 seconds
  //   }, 5000);

  //   // Initial call to set event time when component mounts
  //   updateEventTime();

  //   // Cleanup function when component unmounts
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  // check and update camera state if it exceed 7 mins
  const checkAndUpdateCameraData = () => {
    setCameraData((prevCameraData) => {
      return prevCameraData.map((cameraItem) => {
        if (!cameraItem.eventID) return cameraItem;

        let isStale = false;

        if (cameraItem.eventAddedTime) {
          const added = moment.utc(cameraItem.eventAddedTime);
          const now = moment.utc();

          // Calculate difference in minutes (floating point)
          const diffMinutes = now.diff(added, 'minutes', true);

          // Log details for debugging
          // console.log(`[Camera: ${cameraItem.pumpName}] OCR: ${cameraItem.ocr || 'N/A'}, eventAddedTime: ${cameraItem.eventAddedTime}`);
          // console.log(`Current UTC time: ${now.toISOString()}`);
          // console.log(`Difference in minutes: ${diffMinutes.toFixed(2)}`);

          isStale = diffMinutes > 7;
        } else {
          // console.log(`[Camera: ${cameraItem.pumpName}] No eventAddedTime present to check.`);
        }

        if (isStale) {
          // console.log(`[Camera: ${cameraItem.pumpName}] Event is stale (>7 mins), clearing data.`);
          return {
            ...cameraItem,
            eventID: "",
            ocr: "",
            previousOffenceType: "",
            currentJStime: "",
            eventTime: "",
            eventAddedTime: ""
          };
        }

        return cameraItem;
      });
    });
  };


  useEffect(() => {
    const intervalId = setInterval(() => {
      checkAndUpdateCameraData();
    }, 10000); // Run every 10 seconds

    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, []); // Run when cameraData changes

  const updateSessionStorage = (
    pumpName,
    eventId,
    ocr,
    previousOffenceType
  ) => {
    try {
      let storedData = JSON.parse(localStorage.getItem(pumpName)) || [];
      // Check if previousOffenceType is null, blank, or undefined
      const isPreviousOffenceTypeEmpty =
        !previousOffenceType || previousOffenceType.trim() === "";

      // Check if the eventId already exists in stored data
      const existingIndex = storedData.findIndex(
        (data) => data.eventId === eventId
      );
      if (existingIndex === -1) {
        // If the eventId doesn't exist, add new data
        if (storedData.length < 4) {
          // If we have less than 4 records, add new data directly
          storedData.push({
            eventId,
            ocr,
            previousOffenceType: isPreviousOffenceTypeEmpty
              ? "previousEvent"
              : previousOffenceType,
            pumpName,
            timestamp: new Date().toLocaleString(), // Store current time as timestamp
          });
        } else {
          // If we have exactly 3 records, remove the data from the start (index 0)
          storedData.shift();
          // Add new data at the end
          storedData.push({
            eventId,
            ocr,
            previousOffenceType: isPreviousOffenceTypeEmpty
              ? "previousEvent"
              : previousOffenceType,
            pumpName,
            timestamp: new Date().toLocaleString(), // Store current time as timestamp
          });
        }

        // Update session storage
        // console.log("Updating data into session:", storedData);
        localStorage.setItem(pumpName, JSON.stringify(storedData));
      } else {
        // Log if the eventId already exists
        // console.log(`Event ID ${eventId} already exists. No update needed.`);
      }
    } catch (error) {
      console.error("Error updating session storage:", error);
    }
  };

  // Function to manage session storage based on cameraData state
  const updateSessionStorageWithCameraData = () => {
    cameraData.forEach((camera) => {
      if (camera.eventID !== "") {
        // Update session storage for the pump
        updateSessionStorage(
          camera.pumpName,
          camera.eventID,
          camera.ocr,
          camera.previousOffenceType
        );
      }
    });
  };


  useEffect(() => {
    // Call the function to manage session storage whenever cameraData changes
    updateSessionStorageWithCameraData();

    // eslint-disable-next-line
  }, [cameraData]);


  function cleanDuplicateOCR(data) {
    const ocrMap = {};

    // First pass to find latest entry for each OCR
    data.forEach(entry => {
      if (entry.ocr) {
        const currentEventTime = new Date(entry.eventTime).getTime();
        const existingTime = ocrMap[entry.ocr]
          ? new Date(ocrMap[entry.ocr].eventTime).getTime()
          : 0;

        if (!ocrMap[entry.ocr] || currentEventTime > existingTime) {
          ocrMap[entry.ocr] = entry;
        }
      }
    });

    // Second pass to clean older duplicates
    const cleanedData = data.map(entry => {
      if (
        entry.ocr &&
        ocrMap[entry.ocr] &&
        entry.id !== ocrMap[entry.ocr].id
      ) {
        // console.log(`Duplicate removed: OCR=${entry.ocr}, ID=${entry.id}`);
        return {
          ...entry,
          eventID: "",
          ocr: "",
          previousOffenceType: "",
          eventTime: "",
          currentJStime: "",
        };
      }
      return entry;
    });

    return cleanedData;
  }


  useEffect(() => {
    const timeout = setTimeout(() => {
      const updatedData = cleanDuplicateOCR(cameraData);
      if (JSON.stringify(updatedData) !== JSON.stringify(cameraData)) {
        setCameraData(updatedData);
      }
    }, 2500); // 2.5 second delay

    return () => clearTimeout(timeout); // Clear timeout if cameraData changes before delay finishes
  }, [cameraData]);


  const CameraList = () => (
    <div
      className="grid-container"
      style={{
        display: "grid",
        gridTemplate: `repeat(${gridSize}, 1fr) / repeat(${gridSize}, 1fr)`,
      }}
    >
      {cameraData.map((camera) => (
        <CameraBox
          key={camera.id}
          camera={camera}
          openPopup={openPopup}
          setCameraData={setCameraData}
          pumpCount={pumpCount}
        />
      ))}
    </div>
  );


  const ConnectApps = () => {
    return (
      <div className="outer-container">
        <div className="inner-container">
          <div className="row row-top">
            <div className="col-6 col-left">
              <div
                id="btn-iou"
                className="connect-icon"
                onClick={handleShowIOU}
              >
                <img alt="New IOU" src={iouConnectImage} />
                <h5>New IOU</h5>
              </div>
            </div>
            <div className="col-6 col-right">
              <div
                id="btn-driveoff"
                className="connect-icon"
                onClick={handleShowDriveOff}
              >
                <img alt="New Driveoff" src={driveOffConnectImage} />
                <h5>New Drive-off</h5>
              </div>
            </div>
          </div>
          <div className="row row-bottom">
            <div className="col-6 col-left">
              <div
                id="btn-lookup"
                className="connect-icon"
                onClick={handleShowRegoCheckModal}
              >
                <img alt="Check Suspicious Vehicle" src={lookupConnectImage} />
                <h5>Check suspicious vehicle</h5>
              </div>
            </div>
            <div className="col-6 col-right">
              <div
                id="btn-payment"
                className="connect-icon"
                onClick={handleShowPaymentModal}
              >
                <img alt="Take Payment" src={paymentConnectImage} />
                <h5>Take payment</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (manualInputSuccess !== null) {
      if (manualInputSuccess) {
        // NotificationManager.success("Event created successfully", "Success");
      } else {
        NotificationManager.error(
          <div className="showNormalFont">
            Event creation failed. Please try again later
          </div>,
          <div className="showNormalFont">Error</div>
        );
      }
      setManualInputSuccess(null); // Reset the state to null after showing the notification
    }
  }, [manualInputSuccess]);

  const manualDetect = async () => {
    handleClose();
    const url = `${APP_SERVICES_URL}/sn-events-service/${CustID}/manualDetect?pumpName=${selectedEventData.pumpName}&siteName=${site.name}`;
    // Find the index of the camera data entry to update
    const cameraIndex = cameraData.findIndex(
      (data) => data.pumpName === selectedEventData.pumpName
    );

    if (cameraIndex === -1) return; // Exit if no matching pumpName found

    // Save the current previousOffenceType before making API call
    const previousOffenceType = cameraData[cameraIndex].previousOffenceType;

    // Temporarily set previousOffenceType to "manualDetect"
    setCameraData((prevData) => {
      const updatedData = [...prevData];
      updatedData[cameraIndex].previousOffenceType = "manualDetect";
      return updatedData;
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: authHeader,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        // console.log("Manual Detect API request was successful");
      } else {
        // console.error("Manual Detect API request failed");
        // Revert to original previousOffenceType on failure
        setCameraData((prevData) => {
          const updatedData = [...prevData];
          updatedData[cameraIndex].previousOffenceType = previousOffenceType;
          return updatedData;
        });
      }
    } catch (error) {
      // console.error("Network error:", error);
      // Revert to original previousOffenceType on error
      setCameraData((prevData) => {
        const updatedData = [...prevData];
        updatedData[cameraIndex].previousOffenceType = previousOffenceType;
        return updatedData;
      });
    }
  };

  const getCurrentSiteEvents = async () => {
    try {
      const response = await axios.get(
        `${APP_SERVICES_URL}/sn-events-service/${CustID}/currentSiteEvents`,
        {
          headers: {
            Authorization: authHeader,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        // console.log("Data fetched successfully:", response.data);
        return response.data;
      } else {
        setCurrentSiteEventsError(true);
        // console.log('set error true', currentSiteEventsError)
        return null;
      }
    } catch (error) {
      setCurrentSiteEventsError(true);
      // console.log('set error true', currentSiteEventsError)
      return null;
    }
  };

  const updateCameraDataFromAPI = (apiData) => {
    const now = moment.utc().toISOString();
    setCameraData((prevData) => {
      return prevData.map((camera) => {
        // Find a matching item from the API data
        const matchingApiItem = apiData.find(
          (apiItem) => apiItem.pumpName === camera.pumpName
        );

        // If a match is found, update eventID and ocr
        if (matchingApiItem) {
          return {
            ...camera,
            eventID: matchingApiItem.id,
            ocr: matchingApiItem.ocr,
            previousOffenceType:
              matchingApiItem.previousOffenceType || undefined, // Use empty string if not provided
            currentJStime: now,
            eventTime: matchingApiItem.created,
            eventAddedTime: now,
          };
        }

        // If no match is found, return the camera object unchanged
        return camera;
      });
    });
  };

  // useffect to handle first popup occurs after loggin in
  useEffect(() => {
    const showModalFromStorage = localStorage.getItem("showModal");
    if (showModalFromStorage && showModalFromStorage === "true") {
      setIsModalOpen(true);
      // Once the modal is shown, you can remove the showModal key from session storage
      localStorage.removeItem("showModal");
    }
  }, []);

  // useffect to check past events on every page referesh
  useEffect(() => {
    const fetchSiteEvents = async () => {
      try {
        const data = await getCurrentSiteEvents();
        if (data) {
          // Delay the state update by 2 seconds
          setCurrentSiteEventsResponse(true)
          setTimeout(() => {
            updateCameraDataFromAPI(data);
          }, 2000);
        }
      } catch (error) {
        console.error("Error fetching site events:", error);
      }
    };

    // Call the API on page load/refresh
    fetchSiteEvents();
  }, []);


  useEffect(() => {
    if (currentSiteEventsResponse || sseConnected) {
      setLoading(false);
    }
  }, [currentSiteEventsResponse, sseConnected]);


  useEffect(() => {
    if (shopliftNotificationError !== null) {
      if (shopliftNotificationError) {
        NotificationManager.error(
          <div className="showNormalFont">
            Shoplift incident creation failed. Please try again later
          </div>,
          <div className="showNormalFont">Error</div>
        );
      }
      setShopliftNotificationError(null);
    }
  }, [shopliftNotificationError]);

  const handleCloseModal = () => {
    setSuccess(false);
  };
  const handleCloseModalDriveOff = () => {
    setSuccessDriveOff(false);
  };
  const handleCloseModalIou = () => {
    setSuccessIOU(false);
  };

  const handleCloseModalShoplift = () => {
    setSuccessShoplift(false);
  }

  return (
    <div style={{ height: "100vh" }}>
      {/* Navbar component */}
      <NotificationContainer />
      <NotificationModal
        label={"successPaymentCheck"}
        show={success}
        handleClose={handleCloseModal}
        title={titleData}
        body={bodyData}
      />
      <NotificationModal
        label={"sucessDriveOff"}
        show={successDriveOff}
        handleClose={handleCloseModalDriveOff}
        title={titleData}
        body={bodyData}
      />
      <NotificationModal
        label={"sucessIOU"}
        show={successIOU}
        handleClose={handleCloseModalIou}
        title={titleData}
        body={bodyData}
      />

      <NotificationModal
        label={"sucessSHOPLIFT"}
        show={successShoplift}
        handleClose={handleCloseModalShoplift}
        title={titleData}
        body={bodyData}
      />

      <CenteredMenuModal
        show={showModalMenuModal}
        handleClose={handleClose}
        manualDetect={manualDetect}
        handleShowImageModal={handleShowImageModal}
        handleShowDriveOff={handleShowDriveOff}
        handleShowIOU={handleShowIOU}
        handleShowManualInputModal={handleShowManualInputModal}
        handleShowShopliftingModal={handleShowShopliftingModal}
      />

      <div className="navbarcontainer" style={{ height: "56px" }}>
        <Navbar
          handleShowDriveOff={handleShowDriveOff}
          handleShowIOU={handleShowIOU}
          handleShowPaymentModal={handleShowPaymentModal}
          handleOpenSignalModal={handleOpenSignalModal}
          handleShowStolenPlateModal={handleShowStolenPlateModal}
          handleShowShopliftingModal={handleShowShopliftingModal}
          currentSiteEventsError={currentSiteEventsError}
          liveEventsError={liveEventsError}
        />
      </div>
      <div className="datacontainer">
        {loading && site.product !== "Connect" && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}

        <div id="dashboard" className="zoomable">
          {site.product !== "Connect" ? <CameraList /> : <ConnectApps />}
        </div>
      </div>
      {/* calling all modal here */}
      <IouModal
        selectedOptions={selectedEventData}
        setSelectedEventData={setSelectedEventData}
        show={iouModalShow}
        onHide={handleCloseIOU}
        setSuccessIOU={setSuccessIOU}
        settitleData={settitleData}
        setBodyData={setBodyData}
      />
      <DriveOffModal
        selectedOptions={selectedEventData}
        setSelectedEventData={setSelectedEventData}
        show={driveoffModalShow}
        onHide={handleCloseDriveOff}
        setSuccessDriveOff={setSuccessDriveOff}
        settitleData={settitleData}
        setBodyData={setBodyData}
      />
      <ShowImageModal
        selectedOptions={selectedEventData}
        setCameraData={setCameraData}
        cameraData={cameraData}
        show={imageModalShow}
        onHide={handleCloseImageModal}
      />
      <ManualInputModal
        selectedOptions={selectedEventData}
        setCameraData={setCameraData}
        cameraData={cameraData}
        setManualInputSuccess={setManualInputSuccess}
        show={manualInputModalShow}
        onHide={handleClosemanualInputModal}
      />
      <ReportStolenPlateModal
        show={reportStolenPlateModalShow}
        onHide={handleCloseStolenPlateModal}
      />
      <PaymentModal
        show={showPaymentModal}
        onHide={handleClosePaymentModal}
        setSuccess={setSuccess}
        settitleData={settitleData}
        setBodyData={setBodyData}
      />

      <SignalModal
        show={showModalSignalModal}
        handleClose={handleCloseSignalModal}
      />

      <LogoutModal />

      <LoginInfoModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <RegoCheckModal
        show={regoCheckModalShow}
        onHide={handleCloseRegoCheckModal}
      />
      <ShopLiftingModal
        show={shopliftingModalShow}
        onHide={handleCloseShopliftingModal}
        setSuccessShoplift={setSuccessShoplift}
        settitleData={settitleData}
        setBodyData={setBodyData}
        setShopliftNotificationError={setShopliftNotificationError}
      />
    </div>
  );
};

export default HomePage;